import getNumberString from './metaData/getNumberString.js';
import getNumberValue from './metaData/getNumberValue.js';
import getNumberValues from './metaData/getNumberValues.js';
import getValue from './metaData/getValue.js';
import metaDataProvider from './metaData/metaDataProvider.js';
import findIndexOfString from './findIndexOfString.js';
import getPixelData from './getPixelData.js';
import metaDataManager from './metaDataManager.js';
import loadImage from './loadImage.js';
import register from './register.js';
const metaData = {
    getNumberString,
    getNumberValue,
    getNumberValues,
    getValue,
    metaDataProvider,
};
export default {
    metaData,
    findIndexOfString,
    getPixelData,
    loadImage,
    metaDataManager,
    register,
};
export { metaData, findIndexOfString, getPixelData, loadImage, metaDataManager, register, };
